<template>
  <div class="to-buy">
    <div class="goods-box">
      <div class="goods-image">
        <img :src="goods" />
      </div>
      <div class="goods-msg">
        <div class="goods-name">
          J-DIRECT BOX
          <label>S10</label>
        </div>
        <div class="goods-description">
          日本VPNルｰタｰ内蔵SmartTV BOX
        </div>
        <div class="price-area">
          <div class="price">
            <label>販売価格</label>
            <del>$158</del>
          </div>
          <div class="new-price">
            <label>限定特価</label>
            $<span>{{ price }}</span>
          </div>
        </div>
        <div class="goods-logistics">
          <label>運賃</label>
          海外送料無料
        </div>
        <div class="goods-num">
          <label>数量</label>
          <input
            type="number"
            v-model="num"
          />海外発売記念500台限定

        </div>
        <button
          class="to-buy-btn"
          @click="toBuy()"
        >今すぐ買う</button>
      </div>

    </div>
    <div class="goods-details">
      <div class="goods-details-title">
        製品詳細
      </div>
      <div class="details-title">
        無料プレゼントをセット
      </div>
      <div class="details-msg">
        J-Direct BOXを購入すると129USD分の無料プレゼント！
      </div>
      <div class="details-title">
        J-DIRECT BOX 同梱一覧
      </div>
      <div class="details-msg">
        <label>
          Google Assistant 対応リモコン
        </label>
        <span>
          J-DIRECT BOX S10
        </span>
        <label>
          指マウス
        </label>
        <span>
          HDMIケーブル
        </span>
        <label>
          電源アダブター
        </label>
      </div>
    </div>
  </div>
</template>
<script>
import { goods } from '../../../images/buy/index'
export default {
  data () {
    return {
      goods,
      num: 1,
      price: '128'
    }
  },
  methods: {
    toBuy () {
      let data = {
        goodsMsg: [
          {
            name: 'J-DIRECT BOX S10',
            num: this.num,
            price: this.price,
            image: goods
          }
        ],
        address: {}
      }
      localStorage.setItem('orderMsg', JSON.stringify(data))
      this.$emit('toBuy')
    },
    getproduct () {
      this.$axios({
         method:'post',
         url:'http://203.85.72.1/forcecms_zhongyin20180515/h5/product',//http://192.168.3.32:8086/forcecms_zhongyin/
         headers: {
           'Content-Type': 'application/json',//设置请求头请求格式为JSON
         },
         params:{ kind : 5 }
      }).then((res)=>{
        console.log(res.data.data)
      })
    }
  },
  mounted () {
    this.getproduct()
  }
}
</script>
<style scoped>
.to-buy {
  width: 100%;
  padding-top: 50px;
  min-width: 1100px;
}
.goods-box {
  width: 1100px;
  margin: 0 auto;
  display: flex;
}
.goods-image {
  width: 550px;
  margin-right: 40px;
}
.goods-image img {
  display: block;
  width: 550px;
  border: 2px solid #e4e4e4;
}
.goods-msg {
  width: 550px;
}
.goods-name {
  font-size: 35px;
  font-weight: bold;
  color: #39d8cc;
}
.goods-name label {
  font-weight: normal;
  font-size: 20px;
}
.goods-description {
  font-weight: normal;
  font-size: 25px;
  color: #828282;
}
.goods-msg div {
  margin: 10px 0;
}
.price-area {
  background: #f2f2f2;
  font-size: 20px;
  box-sizing: border-box;
  padding: 10px;
}
.price-area label,
.goods-logistics label,
.goods-num label {
  color: #828282;
  font-size: 20px;
  width: 100px;
  display: inline-block;
}
.price {
  font-size: 20px;
}
.new-price {
  font-size: 20px;
  color: #e96023;
}
.new-price span {
  font-size: 30px;
  font-weight: bold;
}
.goods-logistics {
  font-size: 20px;
}
.goods-num {
  font-size: 20px;
}
.to-buy-btn {
  width: 240px;
  height: 63px;
  background: #39d8cc;
  box-shadow: 0px 1px 22px 0px rgba(4, 208, 193, 0.56);
  border-radius: 6px;
  text-align: center;
  font-size: 30px;
  color: #fff;
  border: none;
  cursor: pointer;
  outline: none;
  transition: all 0.1s;
}
.to-buy-btn:active {
  background: #3efaec;
}
.goods-details {
  width: 1096px;
  margin: 0 auto;
  margin-top: 50px;
  box-sizing: border-box;
  padding: 30px;
  border: solid 2px #e4e4e4;
  margin-bottom: 50px;
}
.goods-details-title {
  font-size: 25px;
  font-weight: bold;
  color: #39d8cc;
}
.details-title {
  font-size: 25px;
  margin-top: 20px;
  font-weight: bold;
  color: #222;
}
.details-msg {
  color: #828282;
  font-size: 25px;
}
.details-msg span {
  display: inline-block;
  margin: 0px 30px;
}
.goods-num input {
  font-size: 25px;
  width: 80px;
  outline: none;
  margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/buy/modules/to-buy.vue